import React, { CSSProperties, useMemo, useState, useEffect } from "react";

import { Popup } from "semantic-ui-react";

import moment from "moment";

import { formatDate } from "react-lib/utils/dateUtils";

// types
export type IconTurnAroundTimeProps = {
  disabled?: boolean;
  exceedTime?: string | null;
  hr?: number;
  min?: number;
  showExceedTime?: boolean;
  style?: CSSProperties;
};

const IMAGES = {
  alarm: "/static/images/lab/alert-alarm.png",
  time: "/static/images/lab/time-line.png",
};

const POPUP_OFFSET: [number, number] = [-10, 0];

const IconTurnAroundTime = (props: IconTurnAroundTimeProps) => {
  const [currentTime, setCurrentTime] = useState(() => moment());

  // อัปเดตเวลาปัจจุบันทุก 1 นาที
  useEffect(() => {
    if (!props.exceedTime) {
      return;
    }

    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 60000); // 60,000 ms = 1 นาที

    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(interval);
    };
  }, [props.exceedTime]);

  const isExceedTime = useMemo(() => {
    if (!props.exceedTime) {
      return false;
    }

    const target = moment(props.exceedTime);

    // เช็คว่าเวลาปัจจุบันเกินเวลาที่กำหนดหรือยัง
    return currentTime.isAfter(target);
  }, [currentTime, props.exceedTime]);

  const formattedDatetime = useMemo(
    () =>
      props.exceedTime ? (
        <>
          {formatDate(moment(props.exceedTime))}, {moment(props.exceedTime).format("HH:mm:ss")}
        </>
      ) : null,
    [props.exceedTime]
  );

  return (
    <>
      {!!props.exceedTime && (
        <Popup
          disabled={props.disabled}
          offset={POPUP_OFFSET}
          position="bottom left"
          content={
            <>
              <div style={{ fontWeight: "bold" }}>Turn around time : </div>
              <div>
                {props.hr} ชั่วโมง {props.min} นาที
              </div>
              <div style={{ fontWeight: "bold" }}>Expected result Date/Time : </div>
              <div>{formattedDatetime}</div>
            </>
          }
          trigger={
            <img
              src={isExceedTime ? IMAGES.alarm : IMAGES.time}
              style={{
                height: "fit-content",
                marginBottom: "-2.5px",
                width: isExceedTime ? "18px" : "17px",
                ...props.style,
              }}
            />
          }
        />
      )}

      {props.showExceedTime && <label style={{ color: "#4b4b4b" }}>{formattedDatetime}</label>}
    </>
  );
};

IconTurnAroundTime.displayName = "IconTurnAroundTime";

export default React.memo(IconTurnAroundTime);
